<template>
  <v-row class="text-center list-pagination">
    <v-col>
      <v-pagination
        v-if="$store.state.searchTotal > 0"
        v-model="$store.state.searchFilters.page"
        :length="paginationLength"
        :total-visible="isDesktopView ? 15 : 6"
        color="#fac400"
        circle
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      />
    </v-col>
  </v-row>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'

export default {
  name: 'ListPagination',

  computed: {
    ...sharedComputed,

    paginationLength() {
      return Math.ceil(
        this.$store.state.searchTotal /
          (this.$store.state.isHomepage
            ? this.$store.state.rowsPerHomePage
            : this.$store.state.searchFilters.rowsPerPage)
      )
    },
  },
}
</script>
